export const validateRoleLoggedUser = value => {
  let user = JSON.parse(localStorage.user);

  return !!user.get_roles.find(
    ({ role, id }) => role.toUpperCase() === value || id === value
  );
};

export const userIsEjecutivoComercial = () => validateRoleLoggedUser("EJECUTIVO COMERCIAL");
export const userIsAsesorCallCenter  = () => validateRoleLoggedUser("ASESOR CALL CENTER");
export const userIsSeller = () => validateRoleLoggedUser("VENDEDOR");
export const userIsCustomer = () => validateRoleLoggedUser("CLIENTE");
export const userIsSuperAdmin = () => validateRoleLoggedUser(8);
export const userIsTechnicalService = () => validateRoleLoggedUser(4);



// WEBPACK FOOTER //
// ./src/util/roleFunctions.js